import { useEffect, useRef, useState } from "react";
import { MacroBuilderStyled } from "./style";
import MacroNodeProvider from "../../ui-components/macro-builder/macroNodeProvider";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../state/store";
import "react-toastify/dist/ReactToastify.css";
import {
  NotificationDataState,
  userDataState,
} from "../../state/storeDataStateType";
import { notificationDataStateActions } from "../../state/notificationDataState";
import { useDispatch } from "react-redux";
import SideModal, {
  SideModalProps,
} from "../../ui-components/side-modal/sideModal";
import {
  sideModalConfigsMacro,
} from "../../ui-components/modal-configs/whatsappMessageBlockConfigs";
import ComponentModal from "../../ui-components/component-modal/componentModal";
import AddNodePopup from "../../ui-components/flow-builder/addNodePopup";
import { NodeConfig } from "../../utilities/flowBuilder.utility";
import { homeDataAction } from "../../state/homeState";
import {
  FirebaseService,
  PartnerStoreSource,
} from "../../services/firebase/FirebaseService";
import { CrmService } from "../../admin/services/CrmService";
import { FrontendNodeType, GetMacrosResponse, MacroNodeCategory, MacroNodeActionType, MacroNodeActionVerb } from "../../ui-components/macro-builder/macroNode.types";
import { flowMetaStateActions } from "../../state/flowMetaState";
import { useOutside } from "../../ui-components/rich-text-editor/useOutside";
import { NodeActionActions } from "../../state/nodeActionState";
import { Toaster } from "@bikdotai/bik-component-library";
import useKeyboardEventListener from "../../utilities/keyboardEventListner";
import { storeInfoStateActions } from "../../state/storeInfoState";
import { BikStore } from "@bikdotai/bik-models/growth/models/store";
import { getCurrentUser } from "../../services/helpers/StoreHelper";
import { nodeClickDataActions } from "../../state/nodeClickDataState";
import { NodeSubType } from "../../models/nodeSubType";
interface MacroBuilderProps {
  userData: userDataState;
  forceFetch?: boolean;
}

const MacroBuilder = (props: MacroBuilderProps) => {
  const { storeId, macroId, type } = useParams();
  const homeState = useAppSelector((state) => state.homeState);
  const dispatcher = useDispatch();
  const notificationDataState = useAppSelector(
    (state) => state.notificationDataState
  );
  const crmService = new CrmService();
  const nodeClickState = useAppSelector((state) => state.nodeClickState);
  const [showRightModal, setShowRightModal] = useState<boolean>(false);
  const [config, setConfig] = useState<NodeConfig>(new NodeConfig());
  const [index, setIndex] = useState<number>(1);
  const [stickyIndex, setStickyIndex] = useState<number>(0);
  const [newNodeData, setNewNodeData] = useState<{ [key: string]: any }>({});
  const [showLeftModal, setShowLeftModal] = useState<boolean>(false);

  // Primary channel for the side panel (defaults to whatsapp)
  const primaryChannel = homeState.channel || "whatsapp";

  const nodeSubtypeMapping = useAppSelector(
    (state) => state.nodeSubtypeMappingState
  );
  const firebaseService = new FirebaseService(
    () => { },
    () => { }
  );
  const superRef = useRef<HTMLDivElement | null>(null);
  const nodeActions = useAppSelector((state) => state.nodeActionState);
  const [sideModalConfigs, setSideModalConfigs] = useState<{
    [key: string]: Partial<SideModalProps>;
  }>({});
  const [toasterString, setToasterString] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [toasterType, setToasterType] = useState<any>("info");
  const [isBikIntegrated, setIsBikIntegrated] = useState<boolean>(false);
  const [isManifestStore, setIsManifestStore] = useState<boolean>(false);

  //Initializing Keyboard Event listener - This captures keyboard event and handles them accordingly.
  useKeyboardEventListener();

  useOutside(superRef, () => setShowRightModal(false));


  useEffect(() => {
    dispatcher(homeDataAction.updateState({ isMacro: true }));
  }, []);

  // Set macro-specific sideModalConfigs
  useEffect(() => {
    setSideModalConfigs(sideModalConfigsMacro);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let storedUser = JSON.parse(
        localStorage.getItem("Bik/CurrentUser") || "{}"
      );

      const authUser = await FirebaseService.fetchCurrentUser();
      const authUid = authUser?.uid ?? "";

      if (
        !Object.keys(storedUser).length ||
        storedUser.authUid !== authUid ||
        storedUser.storeId !== homeState?.storeId
      ) {
        const currentUser = await getCurrentUser(
          homeState?.storeId,
          authUser?.email ?? ""
        );

        storedUser = currentUser?.id
          ? { ...currentUser, authUid, storeId: homeState?.storeId }
          : {};
        localStorage.setItem("Bik/CurrentUser", JSON.stringify(storedUser));
      }

      if (storedUser.id) {
        dispatcher(
          homeDataAction.updateState({
            userData: { ...homeState?.userData, agentId: storedUser.id },
          })
        );
      }

      const bikStoreData: BikStore = (await firebaseService.getBikStoreData(
        storeId || ""
      )) as BikStore;

      if (bikStoreData && bikStoreData.appType === "GLOBAL") {
        // Check if Bik is integrated for Manifest store
        setIsManifestStore(true);
        const _isBikIntegrated = await getIsBikIntegrated(bikStoreData);
        if (_isBikIntegrated) {
          setIsBikIntegrated(true);
        } else {
          setIsBikIntegrated(false);
        }
      }
    };

    if (homeState?.userData?.email && homeState?.storeId) {
      fetchData();
    }
  }, [homeState?.userData?.email, homeState?.storeId]);

  useEffect(() => {
    // get store info
    firebaseService
      .getStoreInfo(storeId || "")
      .then((data) => {
        dispatcher(
          storeInfoStateActions.addStoreInfoData({
            currency: data?.currency || "INR",
            countryCode: data?.countryCode || "IND",
            timezone: data?.timezone || "",
            partnerStoreDomain:
              data?.storeIntegrationStatus?.partnerStoreDomain,
            chatbotAttributionWindow:
              data?.attributionDetails?.chatbotAttributionWindow || 0,
            productCount: data?.shopifyStats?.productCount || 0,
            isNonShopifyStore:
              (data?.partnerStore?.metaData?.source ?? "")?.toLowerCase() ===
              PartnerStoreSource.CUSTOM || false,
          })
        );
      })
      .catch();
    crmService.getMacros({storeId: storeId!, macroId: macroId!}).then((res) => {
      const response = res as GetMacrosResponse;
      const data = response?.data?.data?.macros?.find((m) => m.macroId === macroId) ?? response?.data?.data?.macros?.[0];
      if (!data) return;
      // Extract channels from root (metaData was flattened)
      const channels = data?.channels || [];
      const channelsString = channels.join(",");

      dispatcher(
        flowMetaStateActions.setFlowMeta({
          flowMeta: {
            [macroId!]: {
              ...data,
              channel: channelsString,
              flowName: data?.title || "",
            },
          },
          updateFlowMeta: true,
        })
      );

      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);

      const last7Days = new Date(today.getTime());
      last7Days.setDate(last7Days.getDate() - 6);
      const startDate = last7Days.getTime();
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      ).getTime();

      dispatcher(
        homeDataAction.addState({
          storeId: storeId || "",
          flowId: macroId || "",
          flowName: data?.title || "",
          type: type || "",
          channel: channelsString || "",
          userData: props.userData,
          status: false,
          lastUpdated: String(data?.updatedAt) || "",
          analyticsData: {
            startDate: startDate,
            endDate: endDate,
          },
          createdAt: String(data?.createdAt),
          journeyType: "utility",
          dndEnabled: false,
          isMacro: true,
        })
      );
    });
  }, [Object.keys(props?.userData)?.length]);

  useEffect(() => {
    if (
      (notificationDataState?.errorMessage || "").length ||
      (notificationDataState?.successMessage || "").length ||
      (notificationDataState?.warningMessage || "").length
    ) {
      showNotification(notificationDataState);
      dispatcher(
        notificationDataStateActions.setNotifications({
          errorMessage: "",
          successMessage: "",
          warningMessage: "",
        })
      );
    }
  }, [
    notificationDataState.errorMessage,
    notificationDataState.successMessage,
    notificationDataState.warningMessage,
  ]);

  useEffect(() => {
    if (nodeClickState.nodeId) {
      setConfig((prevState: NodeConfig) => {
        return {
          ...prevState,
          nodeId: nodeClickState.nodeId,
          type: nodeClickState.nodeType!,
          subType: nodeClickState.nodeSubType!,
          nodeIndex: nodeClickState.nodeIndex!,
          automationChannel: nodeClickState.automationChannel!,
        };
      });

      if (nodeClickState.hideLeftModal) {
        setShowLeftModal(false);
      } else {
        setShowLeftModal(true);
      }
    }
  }, [nodeClickState.nodeId]);

  useEffect(() => {
    if (nodeActions?.type === MacroNodeActionType.NODE && nodeActions?.action === MacroNodeActionVerb.CREATED) {
      setNewNodeData({});
      dispatcher(
        NodeActionActions.updateState({
          type: "",
          action: "",
          nodeId: "",
        })
      );
    }
  }, [nodeActions]);

  const rightModalToggler = () => {
    setShowRightModal((prevState: boolean) => !prevState);
  };

  const closeLeftModal = () => {
    setShowLeftModal(false);
    // Clear nodeClickState so clicking the same node again triggers the modal
    dispatcher(
      nodeClickDataActions.setEditNode({
        nodeId: "",
        nodeType: "",
        nodeSubType: "",
        data: {},
      })
    );
  };
 
  const addNewNode = (nodeName: string) => {
    switch (nodeName) {
      case MacroNodeCategory.JOURNEY: {
        // Create an Action node directly on the builder
        const id = getNodeId();
        const actionIndex = (nodeSubtypeMapping.data?.[NodeSubType.CONNECT_TO_FLOW] || 0) + 1;
        setNewNodeData({
          type: FrontendNodeType.ACTION,
          subType: NodeSubType.CONNECT_TO_FLOW,
          title: `Connect to Flow`,
          nodeIndex: actionIndex,
          id: id,
        });
        setShowRightModal(false);
        break;
      }
      case MacroNodeCategory.ADVANCED: {
        // Open Action blocks side modal
        setNewNodeData({
          type: FrontendNodeType.MESSAGE,
        });
        setShowRightModal(true);
        break;
      }
      case MacroNodeCategory.STICKY_NOTES: {
        const nextStickyIndex = stickyIndex + 1;
        setStickyIndex(nextStickyIndex);
        setNewNodeData({
          type: nodeName,
          subType: NodeSubType.STICKY_NOTES,
          nodeIndex: nextStickyIndex,
          title: `Sticky notes`,
          id: `S${nextStickyIndex}`,
        });
        setShowRightModal(false);
        break;
      }
      default: {
        // Fallback - shouldn't be needed for macros
        break;
      }
    }
  };

  const setNodeDataFromSideModal = (
    blockId: string,
    blockName: string,
    blockChannel?: string,
    blockNodeType?: string
  ) => {
    const id = getNodeId();
    const index = (nodeSubtypeMapping.data?.[blockId] || 0) + 1;
    setNewNodeData((prevState: { [key: string]: string | number }) => {
      return {
        ...prevState,
        type: blockNodeType || prevState.type,
        subType: blockId,
        nodeIndex: index,
        title: `${blockName}`,
        automationChannel: blockChannel || "",
        id: id,
      };
    });
    setShowRightModal((prevState: boolean) => !prevState);
  };

  const showNotification = (notificationDataState: NotificationDataState) => {
    if (notificationDataState.successMessage) {
      setToasterString(notificationDataState.successMessage);
      setToasterType("success");
      setShowToaster(true);
    } else if (notificationDataState.errorMessage) {
      setToasterString(notificationDataState.errorMessage);
      setToasterType("error");
      setShowToaster(true);
    } else if (notificationDataState.warningMessage) {
      setToasterString(notificationDataState.warningMessage);
      setToasterType("warning");
      setShowToaster(true);
    }
  };

  const getNodeId = (): string => {
    let ix = index + 1;
    setIndex(ix);
    return `N${ix}`;
  };

  const getIsBikIntegrated = async (bikStore: BikStore): Promise<boolean> => {
    const partnerDomainUrl =
      bikStore?.storeIntegrationStatus?.partnerStoreDomain;
    const bikStoreId = await firebaseService.isBikIntegratedAlready(
      bikStore.storeId,
      partnerDomainUrl
    );

    if (!bikStoreId || typeof bikStoreId !== "string") {
      return false;
    }
    return true;
  };

  const resetRedux = () => {
    dispatcher({ type: "reset" });
    setIndex((prevIndex: number) => 1);
    setStickyIndex(0);
  };

  useEffect(() => {
    return () => {
      resetRedux();
    };
  }, []);


  return (
    <>
      {showToaster && (
        <Toaster
          text={toasterString}
          type={toasterType}
          autoClose={3000}
          onCloseToast={() => {
            setShowToaster(false);
          }}
          width={"300px"}
        />
      )}
      <MacroBuilderStyled>
        <MacroNodeProvider
          forceFetch={props?.forceFetch}
          newNodeData={newNodeData}
          storeId={storeId!}
          flowId={macroId!}
          type={type!}
          setIndex={(idx: number) => setIndex(idx)}
          index={index}
          stickyIndex={stickyIndex}
          setStickyIndex={setStickyIndex}
          getNodeId={getNodeId}
        />
        <div
          ref={superRef}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AddNodePopup
            click={addNewNode}
            isActive={showRightModal}
            activeNode={newNodeData?.type?.toString()}
            channel={primaryChannel as string}
            isMacro={true}
          />

          {sideModalConfigs[newNodeData?.type]?.subSections &&
            !PreventSideBar[newNodeData?.subType] && (
              <SideModal
                isOpen={showRightModal}
                storeId={storeId!}
                header={sideModalConfigs[newNodeData?.type]?.header!}
                caption={sideModalConfigs[newNodeData?.type]?.caption!}
                subSections={sideModalConfigs[newNodeData?.type]?.subSections!}
                closeModal={rightModalToggler}
                setNewNodeData={setNodeDataFromSideModal}
                isBikIntegrated={isBikIntegrated}
                isManifestStore={isManifestStore}
              />
            )}
        </div>
        {showLeftModal && (
          <ComponentModal
            storeId={storeId!}
            flowId={macroId!}
            config={config}
            closeModal={closeLeftModal}
          />
        )}
      </MacroBuilderStyled >
    </>
  );
};

const PreventSideBar: { [key: string]: boolean } = {
  // For macros, we don't prevent any sidebar since we handle it differently
};

export default MacroBuilder;
